import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const useStyles = makeStyles(() => ({
  droppableContainer: {
    margin: '20px 0px',
    width: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
}));

function ReactDnD({ data, setData, setModifiedOrderIds, renderItem, renderClone, calledFrom, id }) {
  const classes = useStyles();

  const handleDragEnd = (results) => {
    if (!results.destination) return;
    const temp = [...data];
    const [selectedItem] = temp.splice(results.source.index, 1);
    temp.splice(results.destination.index, 0, selectedItem);
    const modifiedOrderIds = temp.map((d) => d.id);
    setModifiedOrderIds(modifiedOrderIds);
    setData(temp);
  };

  const uniqueDroppableId = `droppable-${calledFrom}-${id || 'default'}`;

  return (
    <DragDropContext onDragEnd={handleDragEnd} key={id}>
      <Droppable
        droppableId={uniqueDroppableId}
        direction="vertical"
        renderClone={renderClone}
      >
        {(provided) => (
          <Grid
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={classes.droppableContainer}
            style={calledFrom === 'collection' ? { maxHeight: '50vh' } : { maxHeight: '55vh' }}
          >
            {data.map((d, i) => (
              <Draggable draggableId={d.id?.toString()} index={i} key={d.id}>
                {/*  eslint-disable-next-line no-shadow */}
                {(provided) => (
                  <Grid
                    style={{ width: '100%' }}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    key={d.id}
                  >
                    {renderItem(d)}
                  </Grid>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </Grid>
        )}
      </Droppable>
    </DragDropContext>
  );
}

export default ReactDnD;
